"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = function (condition, validator) {
  return function (value, values) {
    if (condition(value, values)) {
      return validator(value, values);
    }
    return undefined;
  };
};
var hasAValue = exports.hasAValue = function hasAValue(value) {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.some(function (el) {
      return el;
    });
  }
  return !!value.toString().length;
};